import React from 'react';
import {TextContent} from "../../routes/course/TextContent";
import classNames from "classnames";
import {AiOutlineEdit} from "react-icons/ai";

export function InteractiveTextArea({value, setValue, disabled, placeholder}) {

    const areaClass = classNames("form-control mt-4 p-3",{
        "d-none": disabled
    })

    return (

        <div>
            {
                value.includes("$") || disabled ?
                    <div className={"  px-4   p-2 bg-white border-bottom rounded-top"}>
                        <div className={"d-flex mb-2"}>
                            <AiOutlineEdit size={24} className={"me-2"}/>
                            <p className={"m-0 p-0 fw-bold"}>Du har svart</p>
                        </div>
                        <div className={"py-2"}>
                            {
                                value.split("\n").map(item => (
                                    <TextContent value={item} className={"fw-normal "}/>
                                ))
                            }
                        </div>
                    </div>
                    :
                    null
            }

                 <textarea onChange={(e) => setValue(e.target.value)}
                           value={value}
                           className={areaClass}
                           placeholder={placeholder}
                           disabled={disabled}
                           style={{backgroundColor:"#fefefe"}}
                 ></textarea>

        </div>

    )

}